import { MyPortfolioSkeleton } from './components/skeleton/MyPortfolioSkeleton'
import { useMyPortfolio } from './logic/useMyPortfolio'
import { GuestView } from './views/GuestView'
import { PositionView } from './views/PositionView'
import { useConnectModal } from '@/domain/hooks/wallet'
import { useOpenDialog } from '@/domain/state/dialogs/hooks'
import { withSuspense } from '@/ui/utils/withSuspense'

function MyPortfolioContainer() {
  const {
    positionSummary,
    deposits,
    borrows,
    walletComposition,
    eModeCategoryId,
    guestMode,
    liquidationDetails,
    openSandboxModal,
    chainId,
  } = useMyPortfolio()
  const { openConnectModal = () => {} } = useConnectModal()
  const openDialog = useOpenDialog()

  if (guestMode) {
    return <GuestView openConnectModal={openConnectModal} openSandboxModal={openSandboxModal} />
  }

  return (
    <PositionView
      positionSummary={positionSummary}
      deposits={deposits}
      borrows={borrows}
      walletComposition={walletComposition}
      eModeCategoryId={eModeCategoryId}
      openDialog={openDialog}
      liquidationDetails={liquidationDetails}
      chainId={chainId}
    />
  )
}

const MyPortfolioContainerWithSuspense = withSuspense(MyPortfolioContainer, MyPortfolioSkeleton)
export { MyPortfolioContainerWithSuspense as MyPortfolioContainer }
